import Title from "./Title";

function TitleAndDesc({ title, desc }: { title: string; desc?: string }) {
  return (
    <div className="my-2">
      <Title>{title + "!"}</Title>
      {desc ? <p className="text-textBlack mt-1 text-sm pt-3">{desc}</p> : null}
    </div>
  );
}

export default TitleAndDesc;
